import React from 'react';
import { IconProps } from '.';

const SvgHandPicking = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M19 4.5a1 1 0 0 0-1 1v.368a4.013 4.013 0 0 0-.944-.117c-2.572-.015-5.752.152-7.978.834a4.025 4.025 0 0 0-.67.279L4.322 8.978a4.75 4.75 0 0 0-2.3 2.65L.925 14.766c-.077.22-.185.55-.174.922.016.56.237 1.535 1.24 1.95a2.33 2.33 0 0 0 1.322.147c.273-.051.547-.157.8-.33.065.102.146.2.244.289.403.363.935.394 1.33.332.415-.065.84-.254 1.17-.537.167-.143.277-.307.348-.418l1.953-3.082a1.3 1.3 0 0 1 .409-.406l.788-.493c.019.026.036.052.05.08.056.165.118.411.136.636a.983.983 0 0 1-.005.258l-.001.002-2.214 2.507c-.27.306-.646.778-.724 1.405-.047.372-.032.893.262 1.365l.005.007.005.008c.318.483 1.217 1.153 2.454.683l.042-.016 4.091-2.15c.47-.246.896-.57 1.259-.958L18 14.526a1 1 0 0 0 1 .974h3a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-3Zm.4 1.4v8.2h2.2V5.9h-2.2ZM8.078 13.14l-.27.067a3.25 3.25 0 0 0-2.134 1.717l-.122.248c-.157.421-.257.795-.289 1.093-.03.283.011.396.028.43a.456.456 0 0 0 .178 0c.17-.028.352-.11.477-.218 0 0 .007-.006.02-.024a.98.98 0 0 0 .056-.08l1.953-3.082c.033-.052.067-.102.103-.15Zm1.44-5.12c1.992-.611 4.974-.784 7.53-.77a2.5 2.5 0 0 1 .702.104v5.542a2.33 2.33 0 0 0-.799.556l-2.331 2.49a3.25 3.25 0 0 1-.861.657l-4.006 2.105c-.218.074-.36.045-.447.01a.502.502 0 0 1-.181-.126c-.037-.067-.063-.19-.04-.373.018-.144.116-.322.36-.598l2.198-2.489c.22-.223.318-.494.363-.716.047-.234.047-.47.03-.675a4.38 4.38 0 0 0-.233-1.065l-.013-.037-.017-.036a2.39 2.39 0 0 0-.817-.925c-.755-.516-1.648-.383-2.23-.24l-1.278.317a4.75 4.75 0 0 0-3.12 2.51l-.833 1.69c-.148.26-.317.334-.457.36a.834.834 0 0 1-.449-.048l-.01-.005-.012-.004a.416.416 0 0 1-.227-.212.962.962 0 0 1-.09-.397c-.002-.075.02-.18.09-.383l1.1-3.14a3.25 3.25 0 0 1 1.573-1.812l4.084-2.114c.147-.076.285-.136.42-.177Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgHandPicking;
